import React from 'react'
import styled from '@emotion/styled'
import MuiListItemText, { ListItemTextProps } from '@mui/material/ListItemText'

type ItemTextProps = ListItemTextProps

const StyledListItemText = styled(MuiListItemText)`
  white-space: break-spaces;
`

const ListItemText = (props: ItemTextProps) => {
  return <StyledListItemText {...props} />
}
export default ListItemText
